import Amplitude from '../../../../../tools/amplitude/amplitude';
import { Events } from './Analytics.events';

const logHandOffBagsAndDrinksInput = params =>
  Amplitude.logEvent(Events.handOffBagsAndDrinksInput.name, params);

export const AnalyticsActions = {
  logHandOffBagsAndDrinksInput,
};
